<draggable-container [prefix]="data.prefix">
  <div class="d-flex justify-content-center align-items-center">
    <input class="form-control" type="text" name="text" placeholder="Texto mostrado" [(ngModel)]="data.text">
    <input class="form-control" type="text" name="url" placeholder="Url" [(ngModel)]="data.href" (keyup)="checkUrl()">
  </div>

</draggable-container>
